import { useState, useEffect, useRef } from 'react';
import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input';
import {
  RCVsTable,
  SalesTable,
  UpgradeTable,
  CxCTable,
  RCV_CSTable,
  DueSalesTable,
  ExportableAdminTableV2,
  ExportableSegCorp,
} from '../../common/Tables/Tables';
import {
  RCVsTableHeader,
  UpgradesTableHeader,
  CxCTableHeader,
  exportablesSalesTable,
  exportablesAdminTable,
  exportablesRCVCorpTable,
  exportablesPendingAccounts,
  RCV_CS_TableHeader,
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { membershipService } from '../../../services/membershipService';
import { usersService } from '../../../services/usersService';
import authService from '../../../services/authService';
import { useHistory } from 'react-router-dom';
import {
  FilterDatePicker,
  Select,
  SearchInput,
} from '../../common/Forms/Input/Input';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';
import moment from 'moment';
import {
  filterParams,
  capitalize,
  greatedThanDate,
} from '../../../assets/helpers/funciones';
import { salesRoles } from '../../../assets/helpers/roles';
import './Exportables.scss';
import { OtpModal } from '../../common/Modals/Modals.jsx';
import { ExportableOtpModules } from '../../../assets/helpers/options.js';

const itemsPerpage = [10, 25, 50, 100, 500];

const segCorpDate = '2025-04-29';
const maxRCV_SC_Date = '2025-04-28';

const exportFilter = {
  UPGRADE: 'Upgrade',
  RCV_Report: 'Reporte RCV',
  RCV_CS: 'RCV CS',
  SALES: 'Ventas',
  CxC: 'CxC',
  CUENTAS_POR_COBRAR: 'CxC pagadas',
  ADMINISTRATION: 'Administración',
  RCV_SCORP: 'RCV SCOR (Nuevo)',
  RCV_SCORP_RENEWAL: 'RCV SCORP (Renovaciones)',
};

const isRCVScorpExportType = (type) =>
  [exportFilter.RCV_SCORP, exportFilter.RCV_SCORP_RENEWAL].includes(type);

const getRCVScorpRequestType = (exportType) =>
  exportType === exportFilter.RCV_SCORP_RENEWAL ? 'Renovado' : 'Nuevo';

export const FilterButton = (props) => {
  const { label, type, action } = props;
  if (label === exportFilter?.RCV_Report && !type) {
    return <ActionButton label={label} action={() => action(label)} />;
  }
  if (label === type) {
    return <ActionButton label={label} action={() => action(label)} />;
  } else {
    return <AltButton label={label} action={() => action(label)} />;
  }
};

export const Exportables = () => {
  const tableRef = useRef(null);
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(1, 'week').toDate()
  );
  const [dateTo, setDateTo] = useState(moment().toDate());
  const [getSalesTableHeader, setGetSalesTableHeader] = useState(
    exportablesSalesTable(0)
  );
  const [sellerOptions, setSellerOptions] = useState([]);
  const [seller, setSeller] = useState(
    [
      salesRoles?.SALES_HUNTER,
      salesRoles?.SALES_COUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_KEY_ACCOUNTS,
    ].includes(authService?.getUserType())
      ? authService?.getUser()?._id
      : ''
  );
  const [minDate, setMinDate] = useState('');
  const [maxDate, setMaxDate] = useState('');

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: true,
    searchParam: '',
    type: [salesRoles?.SALES_RCV_SCORP]?.includes(authService.getUserType())
      ? exportFilter?.RCV_SCORP
      : exportFilter?.SALES,
  });

  const [paymentDate, setPaymentDate] = useState({
    dateFrom: moment().subtract(1, 'week').toDate(),
    dateTo: moment(),
  });

  const [uploadDate, setUploadDate] = useState({});

  const handlePaymentDate = (dateFrom, dateTo) => {
    if (dateFrom && dateTo) {
      setPaymentDate({
        dateFrom: moment(dateFrom).toDate(),
        dateTo: moment(dateTo).toDate(),
      });
    }
  };

  const handleUploadDate = (dateFrom, dateTo) => {
    if (dateFrom && dateTo) {
      setUploadDate({
        dateFrom: moment(dateFrom).toDate(),
        dateTo: moment(dateTo).toDate(),
      });
    }
  };

  const selectType = (type) => {
    if (type === membershipsDatatable?.type) {
      return null;
    }

    if (
      [
        exportFilter?.RCV_CS,
        exportFilter?.RCV_SCORP,
        exportFilter?.RCV_SCORP_RENEWAL,
      ].includes(type)
    ) {
      handleLimitDates(type);
    } else {
      setMinDate('');
      setMaxDate('');
    }

    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        data: [],
        count: 0,
        type: type,
        searchParam: '',
        // isLoading: true,
      };
    });
  };

  const setFirstPage = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    let eDate = new Date(moment(e)?.format('DD/MM/YYYY')).getTime();
    let to = new Date(moment(dateTo)?.format('DD/MM/YYYY')).getTime();

    if (eDate > to && dateTo) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    let eDate = new Date(moment(e)?.format('DD/MM/YYYY')).getTime();
    let from = new Date(moment(dateFrom)?.format('DD/MM/YYYY')).getTime();

    if (eDate < from && dateFrom) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };

  const selectSeller = (e) => {
    const { value } = e?.target;
    setSeller(value);
  };

  const exportTable = () => {
    if (
      [exportFilter?.RCV_Report, exportFilter?.RCV_CS].includes(
        membershipsDatatable?.type
      )
    ) {
      exportRCVs();
    }

    if ([exportFilter?.SALES]?.includes(membershipsDatatable?.type)) {
      getSalesExportable(true);
    }

    if ([exportFilter?.UPGRADE]?.includes(membershipsDatatable?.type)) {
      getUpgradesExportable(true);
    }

    if (
      [exportFilter?.CUENTAS_POR_COBRAR]?.includes(membershipsDatatable?.type)
    ) {
      getAccountsReceivable(true);
    }

    if ([exportFilter?.CxC]?.includes(membershipsDatatable?.type)) {
      getPendingDues(true);
    }

    if ([exportFilter?.ADMINISTRATION]?.includes(membershipsDatatable?.type)) {
      getAdminTableData(true);
    }

    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      getRCVSeguroCorporativo(true);
    }
  };

  const showOtp = () => {
    const data = {};

    switch (membershipsDatatable?.type) {
      case exportFilter?.RCV_CS:
        data.module = ExportableOtpModules.RCV_EXPORTABLE;
        break;
      case exportFilter?.RCV_Report:
        data.module = ExportableOtpModules.RCV_EXPORTABLE;
        break;
      case exportFilter?.SALES:
        data.module = ExportableOtpModules.SALES;
        break;
      case exportFilter?.CUENTAS_POR_COBRAR:
        data.module = ExportableOtpModules.PENDING_PAYMENT;
        break;
      case exportFilter?.ADMINISTRATION:
        data.module = ExportableOtpModules.ADMIN_SALES;
        break;

      case exportFilter?.UPGRADE:
        data.module = ExportableOtpModules.MEMBERSHIP_EXPORTABLE;
        break;

      default:
        break;
    }

    if (!otpCode && !isLoading) {
      authService
        .sendOtp(data)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify('Ingrese el código OTP enviado a su correo', 'Success');
            setShowOtpModal(true);
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    }
  };

  const downloadZip = () => {
    let params = {
      // status: validateIdLogic(),
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
    };

    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      params.page = membershipsDatatable?.page;
      params.type = getRCVScorpRequestType(membershipsDatatable?.type);
      delete params.offset;
    }
    notify(`Descarga iniciada`, 'success');

    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      membershipService
        .ZipRCV_SCORP(params)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify(`Descarga iniciada`, 'success');
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    } else {
      membershipService
        .ZipRCV(params)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify(`Descarga iniciada`, 'success');
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const redirectToEditOrder = (orderId) => {
    history.push(`/afiliations/edit-order/${orderId}`);
  };

  const redirectToOrderDetail = (order) => {
    history.push(
      `/afiliations/order-details/${order?._id}/vehicle/${order?.vehicle?._id}`
    );
  };

  const renewMembership = (membership) => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .reativateMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Membresia reactivada`, 'success');
            redirectToEditOrder(membership?._id);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const handleLimitDates = (type) => {
    if (isRCVScorpExportType(type)) {
      setMinDate(new Date(segCorpDate));
      setDateFrom(moment().subtract(2, 'month').toDate());
      return;
    }

    if (!greatedThanDate(dateFrom, '2024-03-01')) {
      setDateFrom(new Date('2024-03-02'));
    }

    if (type === exportFilter?.RCV_CS) {
      setMaxDate(new Date(maxRCV_SC_Date));
      if (greatedThanDate(dateTo, maxRCV_SC_Date)) {
        setDateTo(new Date(maxRCV_SC_Date));
      }
      if (greatedThanDate(dateFrom, maxRCV_SC_Date)) {
        setDateFrom(new Date(maxRCV_SC_Date));
      }
    }
    setMinDate(new Date('2024-03-02'));
  };

  const preloadDates = () => {
    if (
      membershipsDatatable?.type === exportFilter?.RCV_CS ||
      [salesRoles?.RCV]?.includes(authService.getUserType())
    ) {
      setMinDate(new Date('2024-03-02'));
      setMaxDate(new Date(maxRCV_SC_Date));
    }

    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      setDateFrom(moment().subtract(2, 'month').toDate());
      setMinDate(new Date(segCorpDate));
    }

    let from = new Date();
    from = from.setDate(from.getDate() - 7);
    from = new Date(from);
    setDateFrom(from);
    setDateTo(new Date());

    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = urlParams.get('from');
    const to = urlParams.get('to');
    const sellerParam = urlParams.get('seller');
    getUsers();

    if (fromUrl) {
      const fromDate = moment(fromUrl).startOf('month').toDate();
      if (fromDate) {
        setDateFrom(fromDate);
      }
    }
    if (to) {
      const toDate = moment(to).endOf('month').toDate();
      if (toDate) {
        setDateTo(toDate);
      }
    }

    if (sellerParam) {
      setSeller(sellerParam);
    } else {
      setSeller('');
    }
    getData();
  };

  const handleSearchChange = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        // page: 1,
        // offset: 0,
        // data: false,
      };
    });
  };

  const defineType = (type) => {
    if (type === exportFilter?.SALES) {
      return 'SALES';
    }
    if (type === exportFilter?.ADMINISTRATION) {
      return 'ADMIN';
    } else return '';
  };

  const getSalesExportable = async (byMail) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    let params = {};
    let body = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      dateFrom: moment(dateFrom).format('YYYY-MM-DD'),
      dateTo: moment(dateTo).format('YYYY-MM-DD'),
    };

    if (body.status === '') {
      delete body.status;
    }
    if (seller) {
      if (seller === 'Sin asesor') {
        body.sellers = null;
      } else {
        body.sellers = [seller];
      }
    }

    if (membershipsDatatable?.searchParam) {
      body.searchParam = membershipsDatatable?.searchParam;
    }

    if (byMail === true) {
      body.byMail = true;
    }

    if (membershipsDatatable?.searchParam) {
      body.searchParam = membershipsDatatable?.searchParam;
    }

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      body.byMail === true
    ) {
      body.otp = otpCode;
    }

    membershipService
      .getSalesExportable(params, body)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          } else {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.memberships,
                count: response?.data?.total,
                paymentsQty: response?.data?.maxPayCount,
                isLoading: false,
              };
            });
            setGetSalesTableHeader(
              exportablesSalesTable(response?.data?.maxPayCount)
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setMembershipsDatatable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const getUpgradesExportable = async (byMail) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    let params = {};
    let body = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      dateFrom: dateFrom
        ? moment(dateFrom).format('YYYY-MM-DD')
        : moment().subtract(1, 'month').format('YYYY-MM-DD'),
      dateTo: dateTo
        ? moment(dateTo).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD'),
      // byMail: true,
    };

    if (byMail) {
      body.byMail = true;
    }

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      body.byMail === true
    ) {
      body.otp = otpCode;
    }

    membershipService
      .getUpgradesExportable(params, body)
      .then((response) => {
        if (response.status === 200) {
          if (byMail) {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          } else {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.memberships,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setMembershipsDatatable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  useEffect(() => {
    preloadDates();
  }, []);

  useEffect(() => {
    getData();
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.type,
    membershipsDatatable?.limit,
    seller,
    dateFrom,
    dateTo,
    seller,
    paymentDate,
    uploadDate,
  ]);

  const exportMembershipTable = () => {
    let params = {
      // status: validateIdLogic(),
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      search: [exportFilter?.RCV_CS]?.includes(membershipsDatatable?.type)
        ? membershipsDatatable?.searchParam
        : '',
      isExportable: true,
      seller:
        [exportFilter?.UPGRADE]?.includes(membershipsDatatable?.type) &&
          [salesRoles?.SALES_ADMIN_AUX]?.includes(authService?.getUserType())
          ? ''
          : seller,
      upgrades:
        membershipsDatatable?.type === exportFilter?.UPGRADE ? true : '',
      byMail: true,
      email: authService?.getUser()?.email,
      type: defineType(membershipsDatatable?.type),
    };

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      params.byMail === true
    ) {
      params.otp = otpCode;
    }

    setIsLoading(true);

    membershipService
      .getMembershipsByStatus(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          setOtpCode('');
          setShowOtpModal(false);
          notify(
            `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
            'info'
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => { });
  };

  const getAdminTableData = (byMail) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    if (!dateFrom || !dateTo) {
      return null;
    }

    let params = {
      from: paymentDate?.dateFrom
        ? moment(paymentDate?.dateFrom).format('YYYY-MM-DD')
        : '',
      to: paymentDate.dateTo
        ? moment(paymentDate?.dateTo).format('YYYY-MM-DD')
        : '',
      fromSaved: uploadDate?.dateFrom
        ? moment(uploadDate?.dateFrom).format('YYYY-MM-DD')
        : '',
      toSaved: uploadDate?.dateTo
        ? moment(uploadDate?.dateTo).format('YYYY-MM-DD')
        : '',
      perPage: membershipsDatatable?.limit,
      page: membershipsDatatable?.page,
      byMail: byMail ? true : false,
      // seller: seller,
    };

    if (membershipsDatatable?.searchParam) {
      params.search = membershipsDatatable?.searchParam;
    }

    //* UNCOMMENT SI SE SOLICITA OTP PARA EXPORTABLES DE ADMINISTRACION

    // if (
    //   ![
    //     salesRoles?.SALES_ADMIN,
    //     salesRoles?.SALES_ADMIN_AUX,
    //     salesRoles?.SALES_DEVELOPER,
    //     salesRoles?.SALES_SUPERVISOR,
    //   ].includes(authService?.getUserType()) &&
    //   params.byMail === true
    // ) {
    //   params.otp = otpCode;
    // }

    membershipService
      .getAdminTableData(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          if (params.byMail === true) {
            setMembershipsDatatable((prevState) => ({
              ...prevState,
              isLoading: false,
            }));
            setOtpCode('');
            setShowOtpModal(false);

            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          } else {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                count: response.data.total,
                data: response.data.data,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        setMembershipsDatatable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
  };

  const getRCVSeguroCorporativo = (byEmail) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    if (!dateFrom || !dateTo) {
      return null;
    }

    let params = {
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      page: membershipsDatatable?.page,
      byEmail: byEmail ? true : false,
      type: getRCVScorpRequestType(membershipsDatatable?.type),
    };

    if (membershipsDatatable?.searchParam) {
      params.search = membershipsDatatable?.searchParam;
    }

    membershipService
      .getRCVSeguroCorporativo(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          if (byEmail) {
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          } else {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                count: response.data.total,
                data: response.data.data,
                isLoading: false,
              };
            });
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setMembershipsDatatable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
  };

  const getAccountsReceivable = (byMail) => {
    let params = {
      // status: validateIdLogic(),
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      byMail: byMail ? true : false,
      offset: membershipsDatatable?.offset,
    };
    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      params.byMail === true
    ) {
      params.otp = otpCode;
    }

    membershipService
      .getAccountsReceivable(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          if (!byMail) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.memberships,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getPendingDues = (byMail) => {
    let params = {
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      byMail: byMail ? true : false,
    };

    membershipService
      .getPendingDues(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          if (!byMail) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.data,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            setOtpCode('');
            setShowOtpModal(false);
            notify(
              `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
              'info'
            );
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getUsers = async () => {
    let params = {
      limit: 1000000,
      offset: 0,
      module: 'Ventas',
      status: 'Activo',
    };
    usersService
      .getUsers(params)
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          if (
            ![
              salesRoles?.SALES_HUNTER,
              salesRoles?.SALES_COUNTER,
              salesRoles?.SALES_FARMER,
              salesRoles?.SALES_KEY_ACCOUNTS,
            ].includes(authService?.getUserType())
          ) {
            data.push({
              _id: '',
              name: 'Todos',
            });

            authService.getUserType() === salesRoles?.SALES_ADMIN &&
              data.push({
                _id: null,
                name: 'Sin asesor',
              });
          }
          for (let i = 0; i < response?.data?.users?.length; i++) {
            data?.push({
              _id: response?.data?.users[i]?._id,
              name:
                capitalize(response?.data?.users[i]?.firstName) +
                '  ' +
                capitalize(response?.data?.users[i]?.lastName),
            });
          }

          let user = localStorage.getItem('user');
          user = JSON.parse(user);
          let [selectedSeller] = data?.filter((s) => s?._id === user?._id);

          // IF not admin can only see global and own metrics
          if (
            ![
              salesRoles?.SALES_ADMIN,
              salesRoles?.SALES_HUNTER,
              salesRoles?.SALES_COUNTER,
              salesRoles?.SALES_FARMER,
              salesRoles?.SALES_KEY_ACCOUNTS,
            ].includes(authService?.getUserType())
          ) {
            setSellerOptions([
              {
                _id: '',
                name: 'Todos',
              },
              selectedSeller,
            ]);
          } else {
            setSellerOptions(data);
          }

          if (
            selectedSeller &&
            ![salesRoles?.SALES_ADMIN].includes(authService?.getUserType())
          ) {
            setSeller(selectedSeller?._id);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getData = () => {
    if ([salesRoles?.RCV]?.includes(authService.getUserType())) {
      setMembershipsDatatable((prevState) => {
        return {
          ...prevState,
          page: 1,
          offset: 0,
          type: exportFilter?.RCV_CS,
        };
      });
      getRCVs();
      return null;
    }
    if ([salesRoles?.SALES_RCV_SCORP]?.includes(authService.getUserType())) {
      if (!isRCVScorpExportType(membershipsDatatable?.type)) {
        setMembershipsDatatable((prevState) => ({
          ...prevState,
          type: exportFilter?.RCV_SCORP,
        }));
      }
      getRCVSeguroCorporativo();
      return null;
    }

    // getRCVs();
    if (
      [exportFilter?.CUENTAS_POR_COBRAR].includes(membershipsDatatable?.type)
    ) {
      getAccountsReceivable();
    }
    if ([exportFilter?.CxC].includes(membershipsDatatable?.type)) {
      getPendingDues();
    }
    if (
      [exportFilter?.RCV_Report, exportFilter?.RCV_CS].includes(
        membershipsDatatable?.type
      )
    ) {
      getRCVs();
    }

    if ([exportFilter?.SALES]?.includes(membershipsDatatable?.type)) {
      getSalesExportable();
    }

    if ([exportFilter?.UPGRADE]?.includes(membershipsDatatable?.type)) {
      getUpgradesExportable();
    }

    if ([exportFilter?.ADMINISTRATION]?.includes(membershipsDatatable?.type)) {
      getAdminTableData();
    }
    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      getRCVSeguroCorporativo();
    }
  };

  const exportRCVs = () => {
    let params = {
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      byEmail: true,
      rcvType: membershipsDatatable?.type === exportFilter?.RCV_CS ? 'sc' : '',
      email: authService?.getUser()?.email,
    };

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      params.byEmail === true
    ) {
      params.otp = otpCode;
    }

    setIsLoading(true);
    membershipService
      .getRCVs(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          setOtpCode('');
          setShowOtpModal(false);
          notify(
            `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
            'info'
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => { });
  };

  const getRCVs = () => {
    if (dateFrom && dateTo) {
      setMembershipsDatatable((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });

      if (!dateFrom || !dateTo) {
        return null;
      }

      let params = {
        dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
        dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
        limit: membershipsDatatable?.limit,
        offset: membershipsDatatable?.offset,
        search: [exportFilter?.RCV_CS]?.includes(membershipsDatatable?.type)
          ? membershipsDatatable?.searchParam
          : '',
      };

      membershipService
        .getRCVs(filterParams(params))
        .then((response) => {
          if (response.status === 200) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.memberships,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
      return true;
    }
  };

  const handleAdminHeaderFilters = () => {
    exportablesAdminTable.forEach((header) => {
      if (header.name === 'Fecha de pago') {
        header.filterSearch = handlePaymentDate;
        header.sortable = true;
      } else if (header.name === 'Fecha de carga') {
        header.filterSearch = handleUploadDate;
        header.sortable = true;
      }
    });
    if (isRCVScorpExportType(membershipsDatatable?.type)) {
      handleLimitDates(membershipsDatatable?.type);
    }

    return exportablesAdminTable;
  };

  useEffect(() => {
    handleAdminHeaderFilters();
  }, []);

  return (
    <>
      <LoadSpinner show={membershipsDatatable?.isLoading || isLoading} />
      <Header />
      {showOtpModal && (
        <OtpModal
          show={showOtpModal}
          handleClose={() => {
            setShowOtpModal(false);
            setOtpCode('');
          }}
          code={otpCode}
          setCode={setOtpCode}
          handleExport={exportTable}
        />
      )}
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Exportables: {membershipsDatatable?.count}
          </h1>

          <div className="buttons-center-container">
            {[
              exportFilter?.RCV_CS,
              exportFilter?.RCV_SCORP,
              exportFilter?.RCV_SCORP_RENEWAL,
            ]?.includes(membershipsDatatable?.type) &&
              [salesRoles?.SALES_ADMIN, salesRoles?.SALES_RCV_SCORP].includes(
                authService?.getUserType()
              ) && (
                <ActionButton
                  label={'Descargar Zip'}
                  action={() => downloadZip()}
                />
              )}
            <ActionButton
              label={'Exportar'}
              action={() => {
                if (
                  ![
                    salesRoles?.SALES_ADMIN,
                    salesRoles?.SALES_ADMIN_AUX,
                    salesRoles?.SALES_DEVELOPER,
                    salesRoles?.SALES_SUPERVISOR,
                    salesRoles?.SALES_RCV_SCORP,
                  ].includes(authService?.getUserType())
                ) {
                  if (
                    [
                      exportFilter?.ADMINISTRATION,
                      exportFilter?.RCV_SCORP,
                      exportFilter?.RCV_SCORP_RENEWAL,
                    ].includes(membershipsDatatable?.type)
                  ) {
                    exportTable();
                  } else {
                    showOtp();
                  }
                } else {
                  exportTable();
                }
              }}
            />
          </div>
        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <div className="exportables-buttons-container">
                {![salesRoles?.RCV, salesRoles?.SALES_RCV_SCORP].includes(
                  authService?.getUserType()
                ) && (
                    <FilterButton
                      label={exportFilter?.SALES}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {[
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_DEVELOPER,
                  salesRoles?.SALES_SUPERVISOR,
                ].includes(authService?.getUserType()) && (
                    <FilterButton
                      label={exportFilter?.RCV_Report}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {[
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_DEVELOPER,
                  salesRoles?.SALES_SUPERVISOR,
                  salesRoles?.RCV,
                ].includes(authService?.getUserType()) && (
                    <FilterButton
                      label={exportFilter?.RCV_CS}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {(![
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_DEVELOPER,
                  salesRoles?.SALES_SUPERVISOR,
                  salesRoles?.RCV,
                  salesRoles?.SALES_RCV_SCORP,
                ].includes(authService?.getUserType()) ||
                  ![salesRoles?.RCV, salesRoles?.SALES_RCV_SCORP].includes(
                    authService?.getUserType()
                  )) && (
                    <FilterButton
                      label={exportFilter?.UPGRADE}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {[
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_DEVELOPER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_KEY_ACCOUNTS,
                ].includes(authService?.getUserType()) && (
                    <FilterButton
                      label={exportFilter?.CxC}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {![
                  salesRoles?.RCV,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_MARKETING,
                  salesRoles?.SALES_RCV_SCORP,
                ].includes(authService?.getUserType()) && (
                    <FilterButton
                      label={exportFilter?.CUENTAS_POR_COBRAR}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {[
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_ADMIN_AUX,
                ].includes(authService?.getUserType()) && (
                    <FilterButton
                      label={exportFilter?.ADMINISTRATION}
                      type={membershipsDatatable?.type}
                      action={selectType}
                    />
                  )}
                {[
                  salesRoles?.SALES_ADMIN,
                  salesRoles?.SALES_RCV_SCORP,
                ].includes(authService?.getUserType()) && (
                    <>
                      <FilterButton
                        label={exportFilter?.RCV_SCORP}
                        type={membershipsDatatable?.type}
                        action={selectType}
                      />
                      <FilterButton
                        label={exportFilter?.RCV_SCORP_RENEWAL}
                        type={membershipsDatatable?.type}
                        action={selectType}
                      />
                    </>
                  )}
              </div>

              {[
                exportFilter?.RCV_CS,
                exportFilter?.ADMINISTRATION,
                exportFilter?.RCV_SCORP,
                exportFilter?.RCV_SCORP_RENEWAL,
                exportFilter?.SALES,
              ]?.includes(membershipsDatatable?.type) && (
                  <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                    <SearchInput
                      placeholder={'Nombre o Apellido, Cédula o Placa'}
                      searchAction={getData}
                      value={membershipsDatatable?.searchParam}
                      onChange={handleSearchChange}
                      width="50px"
                    />
                  </div>
                )}

              {[exportFilter?.SALES]?.includes(membershipsDatatable?.type) && (
                <div className="col-12 col-md-2" style={{ marginTop: '10px' }}>
                  <Select
                    options={sellerOptions}
                    label={'Asesor'}
                    value={seller}
                    onChange={selectSeller}
                    disabled={[
                      salesRoles?.SALES_HUNTER,
                      salesRoles?.SALES_COUNTER,
                      salesRoles?.SALES_FARMER,
                      salesRoles?.SALES_KEY_ACCOUNTS,
                    ].includes(authService?.getUserType())}
                  />
                </div>
              )}
              {membershipsDatatable?.type !== exportFilter?.ADMINISTRATION && (
                <>
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Desde'}
                    type={'date'}
                    name={'dateFrom'}
                    placeholder={''}
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={membershipsDatatable?.isLoading}
                    minDate={minDate}
                    maxDate={maxDate}
                  />

                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Hasta'}
                    type={'date'}
                    name={'dateTo'}
                    placeholder={''}
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={membershipsDatatable?.isLoading}
                    maxDate={maxDate}
                  />
                </>
              )}

              <div className="col-12 col-md-3" style={{ marginTop: '12px' }}>
                <SelectPerPage
                  label={'Registros por página'}
                  options={itemsPerpage}
                  value={membershipsDatatable?.limit}
                  onChange={selectitemsPerpage}
                />
              </div>
            </div>
          </div>
        </div>
        {membershipsDatatable?.type === exportFilter?.RCV_CS && (
          <RCV_CSTable
            header={RCV_CS_TableHeader}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}

        {membershipsDatatable?.type === exportFilter?.CxC && (
          <CxCTable
            header={CxCTableHeader}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}

        {membershipsDatatable?.type === exportFilter?.RCV_Report && (
          <RCVsTable
            header={RCVsTableHeader}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}
        {membershipsDatatable?.type === exportFilter?.UPGRADE && (
          <UpgradeTable
            header={UpgradesTableHeader}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}
        {membershipsDatatable?.type === exportFilter?.SALES && (
          <SalesTable
            header={getSalesTableHeader}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}
        {membershipsDatatable?.type === exportFilter?.CUENTAS_POR_COBRAR && (
          <DueSalesTable
            header={exportablesPendingAccounts}
            data={membershipsDatatable}
            handlePageChange={handlePageChange}
            redirectToEditOrder={redirectToEditOrder}
            redirectToOrderDetail={redirectToOrderDetail}
            renewMembership={renewMembership}
            tableRef={tableRef}
          />
        )}
      </div>
      {membershipsDatatable?.type === exportFilter?.ADMINISTRATION && (
        <ExportableAdminTableV2
          header={exportablesAdminTable}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          redirectToEditOrder={redirectToEditOrder}
          redirectToOrderDetail={redirectToOrderDetail}
          renewMembership={renewMembership}
          tableRef={tableRef}
        />
      )}
      {isRCVScorpExportType(membershipsDatatable?.type) && (
        <ExportableSegCorp
          header={exportablesRCVCorpTable}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          redirectToEditOrder={redirectToEditOrder}
          redirectToOrderDetail={redirectToOrderDetail}
          renewMembership={renewMembership}
        />
      )}
    </>
  );
};
